import React, { Component } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress } from '@mui/material';
import _ from 'lodash';
import { get } from '../../util/api';

class SubsTable extends Component {
	state = { column: null, direction: null, loading: true };
	componentDidMount() {
		this.getData();
	}
	async getData() {
		await get('/maytapi/admin/suspectedOpens').then((data) => this.setState({ data: data.result, loading: false }));
	}

	TableLineCustom = (data) => _.map(data, (val, index) => <Table.Row key={index}></Table.Row>);
	render() {
		let { loading, data } = this.state;
		if (loading)
			return (
				<div>
					<CircularProgress />
				</div>
			);
		return (
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Email</TableCell>
						<TableCell>Date</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(data, function (it, i) {
						return (
							<TableRow key={i}>
								<TableCell>{it.email}</TableCell>
								<TableCell>{it.date}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		);
	}
}

export default SubsTable;
